import { APIModel, APIModelHandler, APIModelImpl } from "./uicomponentapimodel";
import { UIComponentView, UIComponentViewImpl } from "./uicomponentview";
import { UIComponentCSSStyleImpl, UIComponentCSSStyle } from "./uicomponentcss";
import * as React from "react";
import { BaseContext } from '../../utils/basecontext';
import { APIFeatures } from '../../core/util/apifeatures';
import { LogManager, Logger } from '../../utils/logger/logger';


export interface UIComponent<T extends UIDataModel>
{
    getAPIModel(): APIModel;
    getView(): UIComponentView<T>;
    getData(): T;
    clearData(): void;
    validate(): boolean;
    forceUpdateComponent(): void;
}

export interface UIComponentProps 
{
    context: BaseContext;
}

export interface UIComponentState 
{
}

export interface UIComponentHandler 
{
    forceUpdateComponent(): void;
}

export interface UIDataModel 
{

}

export class UIDataModelImpl implements UIDataModel
{

}

export class UIComponentImpl<T extends UIComponentProps, U extends UIComponentState,
 V extends UIDataModel> extends React.Component<T, U>  implements UIComponent<V>, APIModelHandler, UIComponentHandler
{
    private logger: Logger = LogManager.getLogger(UIComponentImpl.name);
    private apiModel: APIModel;
    private uiComponentView: UIComponentView<V>;
    private cssStyle: UIComponentCSSStyle;

    constructor(uiComponentProps: T)
    {
        super(uiComponentProps);
    }

    UNSAFE_componentWillMount()
    {
        this.apiModel = this.createAPIModel(this.getContext(), this);

        this.uiComponentView = this.createComponentView(this.getContext(), this);
        
        this.uiComponentView.bindHandlers();

        this.cssStyle = this.createComponentCSS(this.getContext());
    }

    render()
    {
        return this.getView().draw(this.props, this.state, this.cssStyle);
    }

    forceUpdateComponent(): void
    {
        this.forceUpdate();
    }

    getAPIModel(): APIModel 
    {
        return this.apiModel;
    }

    getView(): UIComponentView<V>
    {
        return this.uiComponentView;
    }

    getStyle():UIComponentCSSStyle
    {
        return this.cssStyle;
    }

    updateStyle(style:UIComponentCSSStyle){
        this.cssStyle = style;
    }

    getData(): V 
    {
       return this.getView().getData();
    }
  
    clearData(): void 
    {
        this.getView().clearData();
    }

    validate(): boolean 
    {
       return this.getView().validate();
    }
    
    onSuccess(feature:APIFeatures, description: string, data: any): void 
    {
        this.logger.log("onSuccess invoked");
        this.logger.log("Feature :" +feature +", Desc :"+description);
        this.logger.log("Data    :" +JSON.stringify(data));
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        this.logger.log("onFailure invoked");
        this.logger.log("Feature :" +feature +", Desc :"+description);
        this.logger.log("Data    :" +JSON.stringify(data));
    }

    protected getContext(): BaseContext
    {
        return this.props.context;
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
        return new APIModelImpl(applicationContext, apiModelHandler);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<V>
    {
        return new UIComponentViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new UIComponentCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/uicomponent.tsx